export default function (axios, config) {
  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function () {
      const response = await axios({
        url: config.serverUrl + '/api/nodes/apiary?_format=json',
        method: 'get',
        withCredentials: true
      })
      if (typeof response.data.result !== 'object') {
        return []
      }

      return Object.values(response.data.result).map(function (row) {
        return {
          id: row.id,
          title: row.title,
          zipCode: row.field_zip
        }
      })
    }),
    getOne: config.cachedFunction(async function (id) {
      return axios({
        url: config.serverUrl + '/api/node/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })
    }),
    save ({ id, title, zipCode, token }) {
      this.invalidate()
      const data = {
        title,
        field_zip: zipCode
      }

      const url = (id ? config.serverUrl + '/api/node/' + id + '?_format=json' : config.serverUrl + '/api/node/apiary?_format=json')

      return axios({
        url,
        method: (id ? 'patch' : 'post'),
        data: data,
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
    },
    deleteItem ({ id, token }) {
      this.invalidate()
      const url = config.serverUrl + '/api/node/' + id + '?_format=json'

      return axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
    }
  }
}
